<template>
  <div>
    <transition
      enter-active-class="slideInUp"
      leave-active-class="slideOutDown"
    >
      <div
        v-if="animateOverlay"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div class="relative w-auto my-6 mx-auto max-w-xs md:max-w-md">
          <!--content-->
          <div
            class="border-0 rounded-lg shadow-lg relative flex flex-col w-full px-6 md:px-12 bg-white outline-none focus:outline-none"
          >
            <!--header-->
            <div class="flex flex-col items-center py-8 rounded-t">
              <img
                class="w-12 h-12"
                :src="require('@/assets/images/alert.svg')"
                alt="alert"
              />
              <h3 class="text-lg font-semibold mt-4">SOS</h3>
            </div>
            <div>
              <form>
                <div class="py-8">
                  <p class="text-base text-gray-600">Event ID</p>

                  <input
                    class="border-b border-solid border-gray-600 mt-3 w-full outline-none"
                    placeholder="12384749958595"
                    v-model="Event.name"
                  />
                </div>
                <!--body-->
                <div class="relative flex-auto">
                  <p class="my-4 text-gray-600 text-sm leading-relaxed">
                    What platform will you like to send your report?
                  </p>
                </div>

                <div class="flex justify-around w-full items-center py-5">
                  <label class="inline-flex items-center">
                    <input
                      type="checkbox"
                      class="form-checkbox focus:outline-none h-5 w-5 text-blue"
                      checked
                    /><span class="ml-2 text-gray-700">Email</span>
                  </label>

                  <label class="inline-flex items-center">
                    <input
                      type="checkbox"
                      class="form-checkbox focus:outline-none h-5 w-5 text-blue"
                      checked
                    /><span class="ml-2 text-gray-700">SMS</span>
                  </label>
                </div>
                <!--footer-->
                <div class="flex items-center justify-center py-5">
                  <button
                    class="w-full h-16 text-white btn-col border-1 outline hover:border-primary font-bold captalize text-sm px-6 py-1 rounded-lg outline-none focus:outline-none mr-1"
                    style="transition: all 0.15s ease"
                    @click.prevent="sendSos()"
                  >
                    <i class="fas fa-spin fa-spinner" v-if="loading"></i>
                    {{ loading ? "" : "SEND SOS" }}
                  </button>
                </div>
                <div class="flex items-center justify-center py-5">
                  <a href="" @click.prevent="overLay()"
                    ><i class="fas fa-close"></i>Close</a
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition
      enter-active-class="slideInUp"
      leave-active-class="slideOutDown"
    >
      <div
        v-if="animateOverlay"
        class="opacity-25 fixed inset-0 z-40 bg-black"
      ></div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";
require("vue2-animate/dist/vue2-animate.min.css");
export default {
  props: {
    animateOverlay: {
      type: Boolean,
      required: true
    },
    overLay: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Event: {
        name: ""
      },
      loading: false
    };
  },
  methods: {
    ...mapActions({
      sendSOS: "sos/sendSOS"
    }),
    sendSos() {
      this.loading = true;
      this.sendSOS(this.Event)
        .then(() => {
          this.$toast.open({
            message: "SOS Successfully sent",
            position: "top-right",
            type: "success"
          });
          this.loading = false;
          this.Event.name = "";
        })
        .catch(() => {
          this.$toast.open({
            message: "Error sending SOS",
            position: "top-right",
            type: "error"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
